import React from "react"

export const ErrorIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    focusable="false"
    data-testid="ErrorIcon"
    width="20"
  >
    <circle cx="12" cy="12" r="10.5" fill="#BC4562" />
    <path
      fill="#fff"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.76517 7.23483C7.61872 7.08839 7.38128 7.08839 7.23483 7.23483C7.08839 7.38128 7.08839 7.61872 7.23483 7.76517L11.4397 11.97L7.23483 16.1748C7.08839 16.3213 7.08839 16.5587 7.23483 16.7052C7.38128 16.8516 7.61872 16.8516 7.76517 16.7052L11.97 12.5003L16.1748 16.7052C16.3213 16.8516 16.5587 16.8516 16.7052 16.7052C16.8516 16.5587 16.8516 16.3213 16.7052 16.1748L12.5003 11.97L16.7052 7.76517C16.8516 7.61872 16.8516 7.38128 16.7052 7.23483C16.5587 7.08839 16.3213 7.08839 16.1748 7.23483L11.97 11.4397L7.76517 7.23483Z"
    />
  </svg>
)
